import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import { useOnboardingContext } from 'Views/Onboarding/Contexts/OnboardingContext';
import SurveyPage from '../../../../Pages/Survey';

const styles = () => ({
  root: {},
});

const Survey = ({ classes }) => {
  const { clientResource } = useOnboardingContext();

  return (
    <div className={classes.root}>
      <SurveyPage
        clientResource={clientResource}
      />
    </div>
  );
};

Survey.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Survey);
